<template>
  <div class="terminal-item">
    <el-popover placement="bottom-end" :title="$t('terminal.Details')" width="200" trigger="hover" :close-delay="0" :offset="200">
      <div>
        <p>{{$t('terminal.deviceName')}}：{{ device.name }}</p>
        <p>{{$t('terminal.group')}}：{{ device.group_name }}</p>
        <p>{{$t('terminal.resolution')}}：{{ device.size_remark }}</p>
        <p>{{$t('terminal.remark')}}：{{ device.remark1 }}</p>
        <p>{{$t('terminal.boxTime')}}：{{ device.time }}</p>
        <p v-if="device.totalSpace != 0">
          {{$t('terminal.deviceZoom')}}：{{`${(device.usableSpace / 1024).toFixed(2)}G/${(device.totalSpace / 1024).toFixed(2)}G`}}
        </p>
        <p v-else>{{$t('terminal.deviceZoom')}}：-</p>
        <p v-if="device.system_version != null && device.type_remark!='Kommander'">
          {{$t('terminal.version')}}：{{ device.system_version }}
        </p>
        <p v-else>{{$t('terminal.version')}}：-</p>
        <p>
          <span>{{$t('terminal.runState')}}：<span :style="'color:' + device.runStateInfo.stateColor">{{ $t(device.runStateInfo.stateName) }}</span></span>
        </p>
        <p>{{$t('terminal.runTime')}}：{{ device.uptimeMills }}</p>
        <p>{{$t('terminal.lastHeart')}}：{{ device.last_heartbeat }}</p>
        <p v-if="device.timeOnOff == undefined ||device.timeOnOff.length == 0">
          {{$t('terminal.timeOpenNo')}}
        </p>
        <p v-else>{{$t('terminal.timeOpen')}}</p>
      </div>
      <div class="img-div" slot="reference">
        <template v-if="device.run_state">
          <div class="img">
            <slot name="img"></slot>
          </div>
        </template>
        <template v-if="device.run_state==0">
          <span class="offline">{{$t('terminal.deviceOff')}}</span>
        </template>
      </div>
      <div class="check-box" slot="reference">
        <slot name="check"></slot>
      </div>
      <div class="device-name" slot="reference">{{device.name}}</div>
      <div class="device-size" slot="reference">{{device.size_remark}}</div>
    </el-popover>
  </div>
</template>

<script>
import { formatDate } from "@/assets/scripts/publicFunction";
export default {
  name: 'TerminalItem',
  props: {
    device: {
      type: Object
    }
  },
  created() {
    this.device.last_heartbeat = formatDate(new Date(this.device.last_heartbeat * 1000), "yyyy-MM-dd hh:mm:ss")
  }
}
</script>

<style lang="scss" scoped>
.terminal-item {
  width: 20%;
  max-width: 240px;
  box-sizing: border-box;
  margin: 4px;
  overflow: hidden;
  border-radius: 4px;
  position: relative;
  .check-box {
    position: absolute;
    left: 10px;
    top: 10px;
  }
  .img-div {
    padding-top: 56.25%;
    background-color: #f5f7fa;
    position: relative;

    .img {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .offline {
      color: red;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .device-name {
    font-family: PingFang-SC-Regular;
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    line-height: 20px;
    letter-spacing: 0vw;
    color: #617883;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    background-color: #eefbff;
    padding-left: 10px;
  }

  .device-size {
    font-family: PingFang-SC-Regular;
    font-size: 11px;
    font-weight: bold;
    font-stretch: normal;
    line-height: 18px;
    letter-spacing: 0vw;
    color: #9cacb4;
    background-color: #eefbff;
    padding-left: 10px;
  }
}
</style>
